import { RightOutlined } from '@ant-design/icons';
import type { ReactNode } from 'react';
import React from 'react';

type IndicatorCardItem = {
    label: string | ReactNode;
    value: number | string | ReactNode;
    color?: 'red' | 'green' | 'blue' | 'yellow' | 'purple' | 'orange' | 'gray';
    onClick?: () => void;
    showArrow?: boolean;
    arrowClassName?: string;
    containerClassName?: string;
    alignment?: 'left' | 'center' | 'right';
    backgroundColor?: string;
}

type IndicatorCardWithCustomTitleProps = {
    title: string | React.ReactNode;
    items: IndicatorCardItem[];
    titleBackgroundColor: string; // 标题背景颜色类名（必填）
    itemsContainerClassName?: string;
}

const IndicatorCardWithCustomTitle = ({
    title,
    items,
    titleBackgroundColor,
    itemsContainerClassName
}: IndicatorCardWithCustomTitleProps) => {
    // 自定义标题渲染
    const titleElement = typeof title === 'string' ? (
        <p className={`text-lg font-medium ${titleBackgroundColor} px-1.7 py-1 rounded text-center`}>
            {title}
        </p>
    ) : title;

    return (
        <div className='flex flex-col gap-2 border-l-4 border-purple-600 pl-2.5'>
            {titleElement}
            <div className={itemsContainerClassName || 'flex gap-2.5'}>
                {items.map((item, index) => (
                    (() => {
                        const justifyClassName = item.alignment === 'left'
                            ? 'justify-start'
                            : item.alignment === 'right'
                                ? 'justify-end'
                                : 'justify-center';

                        return (
                    <div 
                        key={index} 
                        className={`${item.alignment ? "flex flex-col gap-1 items-" + item.alignment : "flex flex-col gap-1 items-center"} ${item.backgroundColor || ''} ${item.onClick ? 'cursor-pointer' : ''} ${item.containerClassName || ''} p-2 rounded-lg transition-colors duration-200`}
                        onClick={item.onClick}
                    >
                        <div className={`relative w-full ${item.showArrow ? 'pr-6' : ''}`}>
                            <div className={`flex items-center ${justifyClassName} gap-1`}>
                                {React.isValidElement(item.value)
                                    ? item.value
                                    : <div className={item.color ? "text-lg text-" + item.color + "-500" : "text-lg"}>{item.value}</div>
                                }
                            </div>
                            {item.showArrow && (
                                <div className={`${item.arrowClassName || 'text-gray-400 text-sm'} absolute right-0 top-1/2 -translate-y-1/2`}>
                                    <RightOutlined />
                                </div>
                            )}
                        </div>
                        {React.isValidElement(item.label) ? item.label : <p className="text-xs text-gray-400">{item.label}</p>}
                    </div>
                        );
                    })()
                ))}
            </div>
        </div>
    )
};

export default IndicatorCardWithCustomTitle;
